export const ARTICLES = [
  {
    slug: "clean-hull-free-horsepower",
    title: "Why a Clean Hull Is Free Horsepower",
    excerpt:
      "Marine growth and oxidation quietly rob your speed and fuel economy. Here's what a clean hull actually does for performance.",
    date: "June 2026",
    readingTime: "4 min read",
    cover:
      "https://images.unsplash.com/photo-1758724803399-bab6108b596b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHw0fHxib2F0JTIwZGV0YWlsaW5nJTIwcG9saXNoaW5nJTIwaHVsbCUyMGNsb3NldXB8ZW58MHx8fHwxNzg2NTY2NTU0fDA&ixlib=rb-4.1.0&q=85",
    body: [
      { type: "p", text: "Every boat owner wants more top-end and better fuel numbers, but few realize how much performance is hiding under the waterline. A layer of slime, barnacles or oxidized gelcoat creates drag — and drag is the enemy of speed." },
      { type: "h", text: "Drag adds up fast" },
      { type: "p", text: "Even a thin biofilm can increase drag enough to shave several miles per hour off your top speed and noticeably raise fuel consumption. On speed and power boats, where every bit of hull efficiency matters, the difference is something you can feel the moment you throttle up." },
      { type: "h", text: "What a proper hull service includes" },
      { type: "p", text: "We strip growth below the waterline, remove oxidation, and polish the gelcoat back to a smooth, drag-free finish. We also check zincs and anodes so your running gear stays protected season after season." },
      { type: "p", text: "The result: a hull that performs as good as it looks — and holds that finish longer." },
    ],
  },
  {
    slug: "wax-vs-ceramic-marine-sealants",
    title: "Wax vs. Ceramic: Which Marine Sealant Is Right for You?",
    excerpt:
      "Both protect your gelcoat from UV and salt, but they behave very differently. A quick, honest breakdown.",
    date: "June 2026",
    readingTime: "5 min read",
    cover:
      "https://images.unsplash.com/photo-1729475003631-118f0aee787d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwyfHxib2F0JTIwZGV0YWlsaW5nJTIwcG9saXNoaW5nJTIwaHVsbCUyMGNsb3NldXB8ZW58MHx8fHwxNzg2NTY2NTU0fDA&ixlib=rb-4.1.0&q=85",
    body: [
      { type: "p", text: "The right protection depends on how you use your boat and how often you're willing to maintain it. Here's how the two compare." },
      { type: "h", text: "Traditional wax" },
      { type: "p", text: "Wax gives a warm, deep shine and is easy to reapply. The trade-off is longevity — it typically lasts weeks to a couple of months on a hard-used boat before it needs a refresh." },
      { type: "h", text: "Ceramic & modern sealants" },
      { type: "p", text: "Ceramic coatings bond to the gelcoat and can last many months, shrugging off UV, salt and water spotting while making wash-downs dramatically easier. It's the choice for owners who want set-and-forget protection." },
      { type: "p", text: "Not sure which fits your boat? Tell us how you ride and we'll recommend the right level." },
    ],
  },
  {
    slug: "spring-commissioning-checklist",
    title: "Your Spring Commissioning Checklist",
    excerpt:
      "Getting your boat water-ready after storage? Run through these detailing essentials before the first launch.",
    date: "June 2026",
    readingTime: "3 min read",
    cover:
      "https://images.unsplash.com/photo-1776977551172-3fe7949714b8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwzfHxtYXJpbmElMjBib2F0JTIwZG9jayUyMGxha2UlMjBtb3VudGFpbnN8ZW58MHx8fHwxNzg2NTY2NTU0fDA&ixlib=rb-4.1.0&q=85",
    body: [
      { type: "p", text: "Winter storage is hard on a boat. Before your first launch of the season, a proper detail sets you up for a clean, trouble-free summer." },
      { type: "h", text: "Exterior" },
      { type: "p", text: "Wash off storage grime, decontaminate the gelcoat, and reapply protection so the finish is ready for sun and water. Address any oxidation now before it spreads." },
      { type: "h", text: "Interior & canvas" },
      { type: "p", text: "Clean and condition vinyl, treat canvas and clears, and knock out any mildew that crept in over winter. Fresh interiors make the whole season better." },
      { type: "p", text: "Want it done for you? Book a spring detail and launch with a boat that looks brand new." },
    ],
  },
];

export const getArticle = (slug) => ARTICLES.find((a) => a.slug === slug);
